exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".home-button{position:absolute;bottom:60px;width:100%;text-decoration:none}.home-button__text{font-family:SorrenMedium;font-size:19px;color:#fff;text-align:center;text-transform:uppercase;letter-spacing:.1em;margin-bottom:15px}.home-button__square{width:38px;margin:auto;display:block;cursor:pointer;height:60px;box-sizing:border-box;border-top:4px solid #99a8e5;border-bottom:4px solid #1e2a77;background-position:0 0,100% 0;background-repeat:no-repeat;background-size:4px 100%;background-image:linear-gradient(180deg,#99a8e5 0,#1e2a77),linear-gradient(180deg,#99a8e5 0,#1e2a77)}.home-button__arrow{text-align:center;position:absolute;margin-left:50%;transform:translate(-50%,-50%);pointer-events:none}.home-button__arrow__line{width:1px;height:50px;margin:auto;background-color:#fff;transform-origin:top}.home-button__arrow__img{transform:translateY(-5px)}.home-btn-st{display:inline-block;white-space:pre}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-3de61608!./~/postcss-loader!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/spa/Home/HomeButton.vue
// module id = 117
// module chunks = 0